import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';

const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(c => !c)} />
      <div 
        className="flex-1 p-8 bg-gray-100 overflow-x-hidden overflow-y-auto h-screen"
        style={{ marginLeft: collapsed ? '64px' : '256px' }}
      >
        <div className='w-full'>
          {children}
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
